"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorTierTableWidget = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var modals = require("./TierTableInfoModalRenderers");
var FalconAccordion_1 = require("../../../../components/FalconAccordion");
var InfoModal_1 = require("../../../../components/modals/InfoModal");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualMotorTierTableWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorTierTableWidget, _super);
    function AnnualMotorTierTableWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAddonChangeEvent = _this.handleAddonChangeEvent.bind(_this);
        return _this;
    }
    AnnualMotorTierTableWidget.prototype.render = function () {
        var _a, _b;
        var selectedTier = this.props.interaction.uistate.selectedCoverTier;
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        var selectedTierClass = (selectedTier && eligibleTiers.includes(selectedTier)) ?
            "selected-tier-" + eligibleTiers.findIndex(function (eligibleTier) { return eligibleTier === selectedTier; }) :
            "no-tier-selected";
        var showProtectNcd = ((_b = (_a = this.props.interaction.policyHolder) === null || _a === void 0 ? void 0 : _a.ncd) === null || _b === void 0 ? void 0 : _b.yearCount) >= 4;
        return (React.createElement(React.Fragment, null,
            this.renderTierCheckboxes(),
            React.createElement("div", { className: "tier-table " + selectedTierClass + " eligible-tiers-" + (0, commonFunctions_1.getEligibleTiers)(this.props.interaction).length },
                this.renderOptionalExtrasBreakDown("Breakdown cover", "optionalExtras.breakdownCover", this.props.interaction.optionalExtras.breakdownCover, this.props.interaction.optionalExtras.breakdownCoverLevel, modals.renderBreakDownCoverModal()),
                this.renderOptionalExtras("Motor legal expenses", "optionalExtras.motorLegalExpenses", this.props.interaction.optionalExtras.motorLegalExpenses, {
                    ALLIANZ_ESSENTIALS: false,
                    ALLIANZ_SILVER: false,
                    ALLIANZ: true
                }, modals.renderMotorLegalExpensesModal()),
                this.renderCustomExtras("Guaranteed hire car", {
                    ALLIANZ_ESSENTIALS: this.getOptionalExtrasElement(false, "optionalExtras.courtesyCar", this.props.interaction.optionalExtras.courtesyCar, undefined, "If your car's stolen, written off or being repaired"),
                    ALLIANZ_SILVER: this.getGHCSilverElement("optionalExtras.courtesyCarTotalLoss", this.props.interaction.optionalExtras.courtesyCarTotalLoss),
                    ALLIANZ: this.getOptionalExtrasElement(true, "optionalExtras.courtesyCar", this.props.interaction.optionalExtras.courtesyCar, "If your car's stolen, written off or being repaired", undefined)
                }, modals.renderGuaranteedHireCarModal()),
                showProtectNcd &&
                    this.renderOptionalExtras("Protected no claim discount", "policyHolder.ncd.doNotDisclose", this.props.interaction.policyHolder.ncd.doNotDisclose, {
                        ALLIANZ_ESSENTIALS: false,
                        ALLIANZ_SILVER: false,
                        ALLIANZ: false
                    }, modals.renderProtectedNoClaimDiscountModal()),
                this.renderIncludedCoverRow("Accidental damage", modals.renderAccidentalDamageModal()),
                this.renderIncludedCoverRow("Fire & theft", modals.renderFireTheftModal()),
                this.renderCoverWithConditions("Driving other cars", {
                    ALLIANZ_ESSENTIALS: "",
                    ALLIANZ_SILVER: "Third party only if eligible",
                    ALLIANZ: "Third party only if eligible",
                }, modals.renderDrivingOtherCarsModal()),
                this.renderCoverWithConditions("European cover", {
                    ALLIANZ_ESSENTIALS: "Minimum compulsory cover you need by law to drive your car in Europe",
                    ALLIANZ_SILVER: "Covered in Europe for up to 90 days a year at the same level as the UK cover",
                    ALLIANZ: "Covered in Europe for up to 180 days a year at the same level as the UK cover",
                }),
                React.createElement(FalconAccordion_1.FalconAccordion, { togglePositionTop: false, toggleHidden: React.createElement("div", { className: "toggle btn-white" },
                        React.createElement("span", null, "Show more cover details"),
                        " ",
                        React.createElement("i", { className: "fas fa-chevron-down glyph-margin" })), toggleShown: React.createElement("div", { className: "toggle accordion-expanded btn-white" },
                        React.createElement("span", null, "Show less cover details"),
                        " ",
                        React.createElement("i", { className: "fas fa-chevron-up glyph-margin" })) }, this.renderAdditionalCoverDetails()),
                this.renderTierLogosRow(),
                this.renderSelectButtons(selectedTier))));
    };
    AnnualMotorTierTableWidget.prototype.bindFromField = function (field) {
        return journey_services_1.ObjectManipulator.fetchFieldValue(field, this.props.interaction);
    };
    AnnualMotorTierTableWidget.prototype.getSelectedTierName = function (coverTier) {
        var tierName = "";
        switch (coverTier) {
            case services_1.MotorCoverTier.ALLIANZ_ESSENTIALS:
                tierName = "allianz-essentials-tier-small";
                break;
            case services_1.MotorCoverTier.ALLIANZ_SILVER:
                tierName = "allianz-silver-tier-small";
                break;
            case services_1.MotorCoverTier.ALLIANZ:
                tierName = "allianz-tier-small";
        }
        return tierName;
    };
    AnnualMotorTierTableWidget.prototype.renderTierLogosRow = function () {
        var _this = this;
        var tiers = new Map();
        tiers.set(services_1.ALLIANZ_ESSENTIALS, "Allianz Essentials");
        tiers.set(services_1.ALLIANZ_SILVER, "Allianz Silver");
        tiers.set(services_1.ALLIANZ, "Allianz");
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        var cols = [];
        var inputBlankCell = (React.createElement("div", { className: "col-4" }));
        cols.push(inputBlankCell);
        tiers.forEach(function (tierName, code) {
            var tierNameImg = _this.getSelectedTierName(code);
            if (eligibleTiers.includes(code)) {
                var input = (React.createElement("div", { className: "col d-flex justify-content-center" },
                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/annual/motor/").concat(tierNameImg, ".svg"), alt: "Tier logo" })));
                cols.push(input);
            }
        });
        return (React.createElement("div", { className: "row logo-row" }, cols));
    };
    AnnualMotorTierTableWidget.prototype.renderTierCheckboxes = function () {
        var _this = this;
        var tiers = new Map();
        tiers.set(services_1.ALLIANZ_ESSENTIALS, "Allianz Essentials");
        tiers.set(services_1.ALLIANZ_SILVER, "Allianz Silver");
        tiers.set(services_1.ALLIANZ, "Allianz");
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        var rows = [];
        tiers.forEach(function (tierName, code) {
            if (eligibleTiers.includes(code)) {
                var isChecked = _this.isChecked(code);
                var backgroundColorClass = isChecked ? "background-color-primary " : "background-color-grey ";
                var wrapperClass = isChecked ? "col tier-input input-selected cursor-pointer" : "col tier-input cursor-pointer";
                var input = (React.createElement("div", { key: code + "div", className: wrapperClass, onClick: function (e) {
                        return _this.props.handleChange(code);
                    }, onKeyDown: function (e) {
                        return _this.props.handleChange(code);
                    }, role: "tab", tabIndex: isChecked ? 0 : 1 },
                    React.createElement("div", { className: backgroundColorClass },
                        React.createElement("div", { className: "pt-3 pb-4 padding-0" },
                            React.createElement("div", { className: "custom-radiobutton-container" },
                                React.createElement("input", { className: "custom-radiobutton", type: "radio", name: code + " checkbox", key: code + " input", value: code, id: code + " checkbox", checked: isChecked, onChange: function (e) { return _this.props.handleChange(code); } })),
                            React.createElement("div", { className: "tier-name" }, tierName),
                            _this.renderPremium(code)))));
                rows.push(input);
            }
        });
        return (React.createElement("div", { className: "row tier-checkboxes position-relative" },
            React.createElement("div", { className: "col-4" }),
            rows));
    };
    AnnualMotorTierTableWidget.prototype.renderAdditionalCoverDetails = function () {
        return (React.createElement(React.Fragment, null,
            this.renderIncludedOrExcludedCoverRow("New car replacement", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderNewCarReplacementModal()),
            this.renderIncludedCoverRow("Windscreen cover", modals.renderWindscreenCoverModal()),
            this.renderCoverWithConditions("In car entertainment", {
                ALLIANZ_ESSENTIALS: "Cover for man­u­fac­tur­er fitted in-car en­ter­tain­ment only",
                ALLIANZ_SILVER: "Cover for man\u00ADu\u00ADfac\u00ADtur\u00ADer fitted in-car en\u00ADter\u00ADtain\u00ADment and up to ".concat((0, commonFunctions_1.getAmountToDisplay)(1000), " for non-man\u00ADu\u00ADfac\u00ADtur\u00ADer fitted"),
                ALLIANZ: "Cover for man\u00ADu\u00ADfac\u00ADtur\u00ADer fitted in-car en\u00ADter\u00ADtain\u00ADment and up to ".concat((0, commonFunctions_1.getAmountToDisplay)(1000), " for non-man\u00ADu\u00ADfac\u00ADtur\u00ADer fitted"),
            }),
            this.renderCoverWithConditions("Personal belongings", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(200),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(300)
            }, modals.renderPersonalBelongingsModal()),
            this.renderIncludedCoverRow("Child car seat replacement", modals.renderChildCarSeatReplacementModal()),
            this.renderCoverWithConditions("Medical expenses", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(250),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(250)
            }, modals.renderMedicalExpensesModal()),
            this.renderIncludedOrExcludedCoverRow("Theft of keys", {
                ALLIANZ_ESSENTIALS: true,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderTheftOfCarKeysModal()),
            this.renderCoverWithConditions("Loss of keys", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(1000),
                ALLIANZ: "Unlimited"
            }, modals.renderLossOfCarKeysModal()),
            this.renderCoverWithConditions("Personal accident cover", {
                ALLIANZ_ESSENTIALS: this.getEssentialsPersonalAccidentCover(),
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(5000),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(10000),
            }, this.getPersonalAccidentCoverInfoModal()),
            this.renderIncludedOrExcludedCoverRow("Misfuelling", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderMisfuellingModal()),
            this.renderIncludedOrExcludedCoverRow("Uninsured driver promise", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderUninsuredDriverPromiseModal()),
            this.renderIncludedOrExcludedCoverRow("Vandalism promise", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderVandalismPromiseModal()),
            this.renderIncludedOrExcludedCoverRow("Accident transport", {
                ALLIANZ_ESSENTIALS: true,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderAccidentTransportModal()),
            this.renderCoverWithConditions("Journey continuation and alternative accommodation costs", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(300),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(500)
            }, modals.renderAlternativeTransportCostsModal()),
            this.renderCoverWithConditions("Car jacking", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(200),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(500)
            }, modals.renderCarJackingModal()),
            this.renderCoverWithConditions("Road rage", {
                ALLIANZ_ESSENTIALS: '',
                ALLIANZ_SILVER: (0, commonFunctions_1.getAmountToDisplay)(200),
                ALLIANZ: (0, commonFunctions_1.getAmountToDisplay)(500)
            }, modals.renderRoadRageModal()),
            this.renderIncludedCoverRow("Motor trade", modals.renderMotorTradersModal()),
            this.renderIncludedCoverRow("Valet parking", modals.renderValetParkingModal()),
            this.renderIncludedOrExcludedCoverRow("EV cables", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderEVCablesModal()),
            this.renderIncludedOrExcludedCoverRow("EV charge point", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderEVChargePointModal()),
            this.renderIncludedCoverRow("EV battery", modals.renderEVBatteryModal()),
            this.renderIncludedCoverRow("EV cable liability", modals.renderEVCablesLiabilityModal()),
            this.renderIncludedOrExcludedCoverRow("EV recovery to nearest charge point", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderEVRecoveryToNearestChargePointModal()),
            this.renderIncludedOrExcludedCoverRow("EV courtesy car", {
                ALLIANZ_ESSENTIALS: false,
                ALLIANZ_SILVER: true,
                ALLIANZ: true
            }, modals.renderEVCourtesyCarModal())));
    };
    AnnualMotorTierTableWidget.prototype.getEssentialsPersonalAccidentCover = function () {
        var _a, _b, _c;
        var policyStartDate = (_b = (_a = this.props.interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : (_c = this.props.interaction.uistate) === null || _c === void 0 ? void 0 : _c.policyPeriodStartDate;
        if ((0, commonFunctions_1.isBeforeIntroductionOfPersonalAccidentCover)(policyStartDate)) {
            return "";
        }
        return (0, commonFunctions_1.getAmountToDisplay)(1000);
    };
    AnnualMotorTierTableWidget.prototype.getPersonalAccidentCoverInfoModal = function () {
        var _a, _b, _c;
        var policyStartDate = (_b = (_a = this.props.interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : (_c = this.props.interaction.uistate) === null || _c === void 0 ? void 0 : _c.policyPeriodStartDate;
        if ((0, commonFunctions_1.isBeforeIntroductionOfPersonalAccidentCover)(policyStartDate)) {
            return modals.renderPersonalAccidentCoverModal();
        }
        return modals.renderNewPersonalAccidentCoverModal();
    };
    AnnualMotorTierTableWidget.prototype.renderIncludedCoverRow = function (title, infoModalContent) {
        var elementsToAdd = [];
        for (var _i = 0, _a = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction); _i < _a.length; _i++) {
            var _1 = _a[_i];
            var element = (React.createElement("div", { className: "col d-flex" },
                React.createElement("span", { className: "wolf-green-tick" })));
            elementsToAdd.push(element);
        }
        return (React.createElement("div", { className: "row addon-row" },
            this.renderTableEntryTitle(title, infoModalContent),
            elementsToAdd));
    };
    AnnualMotorTierTableWidget.prototype.renderPremium = function (tier) {
        var premiumType = this.props.interaction.factors.premiumType;
        var tierFactors = this.getTierFactors(tier);
        var annualPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.annualPremium;
        var monthlyPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.monthlyPremium;
        var tierWording = this.getTierWording(tier);
        var premiumAmount = (premiumType === "annual") ? annualPremium : monthlyPremium;
        var premiumPeriodWording = (premiumType === "annual") ? "year" : "month";
        return (React.createElement(React.Fragment, null,
            ((0, commonFunctions_1.hasPriceForTier)(tier, this.props.interaction.coverTier, this.props.interaction.tieredFactors)) &&
                React.createElement("div", { className: "tier-premium-display" },
                    React.createElement("strong", null, (0, commonFunctions_1.getAmountWithDecimalDigits)(premiumAmount)),
                    React.createElement("span", { className: "margin-bottom-0 premium-type" },
                        " / ",
                        premiumPeriodWording,
                        "*")),
            React.createElement("span", { className: "tier-description" }, tierWording)));
    };
    AnnualMotorTierTableWidget.prototype.getTierFactors = function (tierName) {
        var factors = this.props.interaction.tieredFactors;
        return factors ? factors.find(function (factor) { return factor.tier === tierName; }) : null;
    };
    AnnualMotorTierTableWidget.prototype.getTierWording = function (tierName) {
        switch (tierName) {
            case services_1.ALLIANZ_ESSENTIALS:
                return "Compre­hensive car insurance that covers the basics.";
            case services_1.ALLIANZ_SILVER:
                return "Compre­hensive car insurance with more cover for your peace of mind.";
            default:
                return "Our highest level of compre­hensive car insurance.";
        }
    };
    AnnualMotorTierTableWidget.prototype.renderIncludedOrExcludedCoverRow = function (title, tierCoverSettings, infoModalContent) {
        return (React.createElement("div", { className: "row addon-row" },
            this.renderTableEntryTitle(title, infoModalContent),
            this.renderTableColumn(this.getTierCoverRows(tierCoverSettings))));
    };
    AnnualMotorTierTableWidget.prototype.getTierCoverRows = function (tierSettings) {
        var tierCovers = {};
        for (var _i = 0, _a = Object.entries(tierSettings); _i < _a.length; _i++) {
            var _b = _a[_i], tier = _b[0], included = _b[1];
            tierCovers[tier] = (React.createElement(React.Fragment, null, included
                ? React.createElement("div", { className: "col d-flex" },
                    React.createElement("span", { className: "wolf-green-tick" }))
                : React.createElement("div", { className: "col d-flex" },
                    React.createElement("span", { className: "wolf-red-cross" }))));
        }
        return tierCovers;
    };
    AnnualMotorTierTableWidget.prototype.renderCoverWithConditions = function (title, tierWordings, infoModalContent) {
        var columns = [];
        for (var _i = 0, _a = Object.entries(this.filterEligibleTiers(tierWordings)); _i < _a.length; _i++) {
            var _b = _a[_i], value = _b[1];
            var tierElement = (React.createElement(React.Fragment, null, value
                ? React.createElement("div", { className: "col d-flex font-weight-bold" },
                    React.createElement("p", null, value))
                : React.createElement("div", { className: "col d-flex" },
                    React.createElement("span", { className: "wolf-red-cross" }))));
            columns.push(tierElement);
        }
        return (React.createElement("div", { className: "row addon-row" },
            this.renderTableEntryTitle(title, infoModalContent),
            columns));
    };
    AnnualMotorTierTableWidget.prototype.renderTableColumn = function (elements) {
        return this.filterEligibleTiers(elements);
    };
    AnnualMotorTierTableWidget.prototype.renderTableEntryTitle = function (title, infoModalContent) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-4" },
                React.createElement("div", { className: "margin-bottom-0 d-flex font-weight-bold desktop-w-79 mobile-max-w-89" },
                    title,
                    infoModalContent &&
                        React.createElement(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon", title: title }, infoModalContent)))));
    };
    AnnualMotorTierTableWidget.prototype.renderTableEntryTitleWithModal = function (title, modal) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-4" },
                React.createElement("div", { className: "margin-bottom-0 d-flex font-weight-bold" },
                    title,
                    modal))));
    };
    AnnualMotorTierTableWidget.prototype.renderSelectButtons = function (coverTier) {
        return (React.createElement("div", { className: "row tier-select-buttons bg-color-white" },
            React.createElement("div", { className: "col-4" }),
            this.renderTableColumn({
                ALLIANZ_ESSENTIALS: this.renderSelectButton(coverTier, services_1.ALLIANZ_ESSENTIALS),
                ALLIANZ_SILVER: this.renderSelectButton(coverTier, services_1.ALLIANZ_SILVER),
                ALLIANZ: this.renderSelectButton(coverTier, services_1.ALLIANZ)
            })));
    };
    AnnualMotorTierTableWidget.prototype.renderSelectButton = function (coverTier, cover) {
        var _this = this;
        var wrapperCssClass;
        var cssClass;
        var label;
        if (coverTier === cover) {
            wrapperCssClass = "col selected";
            cssClass = "btn btn-select selected icon-tick-white-before";
            label = "Your chosen cover";
        }
        else {
            wrapperCssClass = "col";
            cssClass = "btn btn-select";
            label = "Select";
        }
        return (React.createElement("div", { className: wrapperCssClass },
            React.createElement("button", { type: "button", className: cssClass, id: "select" + cover, value: cover, onClick: function (e) { return _this.props.handleChange(cover); } }, label)));
    };
    AnnualMotorTierTableWidget.prototype.renderOptionalExtras = function (title, addonField, addonValue, tierSettings, infoModalContent) {
        var tierCovers = {};
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        for (var _i = 0, eligibleTiers_1 = eligibleTiers; _i < eligibleTiers_1.length; _i++) {
            var tier = eligibleTiers_1[_i];
            tierCovers[tier] = this.getOptionalExtrasElement(tierSettings[tier], addonField, addonValue);
        }
        return (React.createElement("div", { className: "row addon-row" },
            this.renderTableEntryTitleWithModal(title, infoModalContent),
            this.renderTableColumn(tierCovers)));
    };
    AnnualMotorTierTableWidget.prototype.renderOptionalExtrasBreakDown = function (title, addonField, addonValue, coverLevel, infoModalContent) {
        var tierCovers = {};
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        for (var _i = 0, eligibleTiers_2 = eligibleTiers; _i < eligibleTiers_2.length; _i++) {
            var tier = eligibleTiers_2[_i];
            tierCovers[tier] = this.getOptionalExtrasBreakDownElement(addonField, addonValue, coverLevel);
        }
        return (React.createElement("div", { className: "row addon-row first-addon-row" },
            this.renderTableEntryTitleWithModal(title, infoModalContent),
            this.renderTableColumn(tierCovers)));
    };
    AnnualMotorTierTableWidget.prototype.renderCustomExtras = function (title, tierCovers, infoModalContent) {
        return (React.createElement("div", { className: "row addon-row" },
            this.renderTableEntryTitleWithModal(title, infoModalContent),
            this.renderTableColumn(tierCovers)));
    };
    AnnualMotorTierTableWidget.prototype.getOptionalExtrasElement = function (included, addonField, addonValue, includedWording, inclusionWording) {
        var _this = this;
        includedWording = !includedWording ? "Included as standard" : includedWording;
        inclusionWording = !inclusionWording ? (addonValue ? "Added" : "Optional") : inclusionWording;
        var buttonLabel = addonValue ? "Remove" : "Add";
        var iconClass = addonValue ? "wolf-green-tick" : "wolf-red-cross";
        return !included ?
            (React.createElement("div", { className: "col d-flex" },
                React.createElement("span", { className: iconClass }),
                React.createElement("div", { className: "text-align-left" },
                    React.createElement("p", { className: "margin-bottom-0" }, inclusionWording),
                    React.createElement("button", { type: "button", className: "mt-0 mb-0 pb-1 blue-link font-weight-bold", onClick: function (e) { return _this.handleAddonChangeEvent(e, addonField, addonValue); } }, buttonLabel)))) :
            (React.createElement("div", { className: "col d-flex" },
                React.createElement("span", { className: "wolf-green-tick" }),
                React.createElement("p", { className: "unlimited-cover" }, includedWording)));
    };
    AnnualMotorTierTableWidget.prototype.getOptionalExtrasBreakDownElement = function (addonField, addonValue, coverLevel) {
        var _this = this;
        var breakdownCoverWording = function (breakdownCoverLevel) {
            switch (breakdownCoverLevel) {
                case services_1.BreakdownCoverLevelEnum.LOCAL:
                    return "Local";
                case services_1.BreakdownCoverLevelEnum.UK:
                    return "National";
                case services_1.BreakdownCoverLevelEnum.EU:
                    return "European";
                default:
                    throw new Error("Unknown Breakdown Cover level: ".concat(breakdownCoverLevel));
            }
        };
        var isAdded = addonValue && coverLevel;
        var inclusionWording = isAdded ? breakdownCoverWording(coverLevel) : "Optional";
        var buttonLabel = addonValue ? "Remove" : "Add";
        var iconClass = addonValue ? "wolf-green-tick" : "wolf-red-cross";
        return (React.createElement("div", { className: "col d-flex" },
            React.createElement("span", { className: iconClass }),
            React.createElement("div", { className: "text-align-left" },
                React.createElement("p", { className: "margin-bottom-0 d-flex" }, inclusionWording),
                React.createElement("button", { type: "button", className: "mt-0 mb-0 pb-1 blue-link font-weight-bold", onClick: function (e) { return _this.handleAddonChangeEvent(e, addonField, addonValue); } }, buttonLabel))));
    };
    AnnualMotorTierTableWidget.prototype.getGHCSilverElement = function (addonField, addonValue) {
        return this.getExtraElementWithTriggerAfter(addonField, addonValue, this.handleAddonChangeEvent);
    };
    AnnualMotorTierTableWidget.prototype.getExtraElementWithTriggerAfter = function (addonField, addonValue, callback) {
        return (React.createElement("div", { className: "col d-flex flex-column" },
            React.createElement("div", { className: "d-flex ghc-info" },
                React.createElement("span", { className: "wolf-green-tick" }),
                React.createElement("div", { className: "text-align-left" },
                    React.createElement("p", { className: "margin-bottom-0 d-flex text-align-left" }, "If your car\u2019s being repaired."))),
            React.createElement("div", { className: "d-flex ghc-additional-info" },
                !addonValue ? React.createElement("span", { className: "wolf-red-cross" }) : React.createElement("span", { className: "wolf-green-tick" }),
                React.createElement("div", { className: "text-align-left" },
                    React.createElement("p", { className: "margin-bottom-0 d-flex text-align-left" }, "If you car's stolen or written off"),
                    React.createElement("button", { type: "button", className: "mt-0 mb-0 pb-1 blue-link font-weight-bold", onClick: function (e) { return callback(e, addonField, addonValue); } }, addonValue ? "Remove" : "Add")))));
    };
    AnnualMotorTierTableWidget.prototype.handleGHCAddonChangeEvent = function (addonField, addonValue) {
        if (addonField === "optionalExtras.courtesyCarTotalLoss") {
            journey_services_1.ObjectManipulator.setField("optionalExtras.courtesyCar", this.props.interaction, !addonValue);
        }
        if (addonField === "optionalExtras.courtesyCar") {
            journey_services_1.ObjectManipulator.setField("optionalExtras.courtesyCarTotalLoss", this.props.interaction, !addonValue);
        }
    };
    AnnualMotorTierTableWidget.prototype.handleAddonChangeEvent = function (event, addonField, addonValue) {
        ["optionalExtras.courtesyCarTotalLoss", "optionalExtras.courtesyCar"].includes(addonField) &&
            this.handleGHCAddonChangeEvent(addonField, addonValue);
        this.props.onAddonChange(event, addonField, addonValue);
    };
    AnnualMotorTierTableWidget.prototype.isChecked = function (id) {
        if (this.isDirectJourneyAndTierNotSelectedAndNB()) {
            return false;
        }
        return id === this.props.interaction.uistate.selectedCoverTier;
    };
    AnnualMotorTierTableWidget.prototype.isDirectJourneyAndTierNotSelectedAndNB = function () {
        var _a = this.props.interaction, source = _a.source, uistate = _a.uistate, process = _a.process;
        return !source && !uistate.selectedCoverTier && process === services_1.INTERACTION_PROCESS_NB;
    };
    AnnualMotorTierTableWidget.prototype.filterEligibleTiers = function (elements) {
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        return Object.keys(elements)
            .filter(function (tier) { return eligibleTiers.includes(tier); })
            .map(function (tier) { return elements[tier]; });
    };
    return AnnualMotorTierTableWidget;
}(React.Component));
exports.AnnualMotorTierTableWidget = AnnualMotorTierTableWidget;
//# sourceMappingURL=AnnualMotorTierTableWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/tierTable/AnnualMotorTierTableWidget.js
// module id = 3228
// module chunks = 0